import React from 'react'
import { useSelector } from 'react-redux'

export default function useGameTableInfo(tempTableId) {
    const tableId = useSelector((state) => state.gameTable.games[tempTableId]?.tableId);
    const gameId = useSelector((state) => state.gameTable.games[tempTableId]?.gameId);
    const currentTime = useSelector((state) => state.lobby.currentLobbyTime);
    const isTourney = useSelector((state) => state.gameTable.games[tempTableId]?.isTourneyGame);
    const tourneyId = useSelector((state) => state.gameTable.games[tempTableId]?.gameDefinition?.tourneyId);
    const smallBlind = useSelector((state) => state.gameTable.games[tempTableId]?.gameDefinition?.smallBlind);
    const bigBlind = useSelector((state) => state.gameTable.games[tempTableId]?.gameDefinition?.bigBlind);

    return {
        tableId: tableId,
        gameId: gameId,
        lobbyTime: currentTime,
        isTourney: isTourney,
        tourneyId: tourneyId,
        smallBlind: smallBlind,
        bigBlind: bigBlind,
    }
}
